import React from "react";
import { useNavigate } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";

function PrivacyPolicyPage() {
  const navigate = useNavigate();

  const handleBackToMain = () => {
    navigate("/");
  };

  return (
    <div className="App">
      <title>Privacy Policy — EffiGen LLC</title>
      <meta
        name="description"
        content="EffiGen LLC privacy policy — how we collect, use, and protect your data."
      />
      <link rel="canonical" href="https://effigen.ai/privacy-policy" />
      <button
        className="back-button"
        onClick={handleBackToMain}
        aria-label="Back to main page"
      >
        ← Back to Main
      </button>
      <PrivacyPolicy />
    </div>
  );
}

export default PrivacyPolicyPage;

